function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { forwardRef } from '@grupoboticario/flora-react-system';
import React from 'react';
export var InvalidIcon = forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51333 0H8.48667L12 3.51333V8.48667L8.48667 12H3.51333L0 8.48667V3.51333L3.51333 0ZM6.66671 2.66669H5.33337V7.33335H6.66671V2.66669ZM6.66671 8.66669C6.66671 9.03488 6.36823 9.33335 6.00004 9.33335C5.63185 9.33335 5.33337 9.03488 5.33337 8.66669C5.33337 8.2985 5.63185 8.00002 6.00004 8.00002C6.36823 8.00002 6.66671 8.2985 6.66671 8.66669Z",
    fill: "#DE1616"
  }));
});
export var ValidIcon = forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 7.00016C0.333008 3.32016 3.31967 0.333496 6.99967 0.333496C10.6797 0.333496 13.6663 3.32016 13.6663 7.00016C13.6663 10.6802 10.6797 13.6668 6.99967 13.6668C3.31967 13.6668 0.333008 10.6802 0.333008 7.00016ZM10.0596 4.05347L5.6663 8.4468L3.93963 6.7268L2.99963 7.6668L5.6663 10.3335L10.9996 5.00013L10.0596 4.05347Z",
    fill: "#0DAB01"
  }));
});
//# sourceMappingURL=components.js.map